import { render, staticRenderFns } from "./BookFlight.vue?vue&type=template&id=2ee8f1ae&scoped=true&"
import script from "./BookFlight.vue?vue&type=script&lang=js&"
export * from "./BookFlight.vue?vue&type=script&lang=js&"
import style0 from "./BookFlight.vue?vue&type=style&index=0&id=2ee8f1ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee8f1ae",
  null
  
)

export default component.exports